import React from 'react';

import { PageTitle } from '../../../components';

import { Link } from 'react-router-dom';



const ChangePwd = () => { 

  const handleSubmit = (event) => {
    event.preventDefault(); // Prevent the default form submission behavior
    // Reset the form fields
    event.target.reset();
  };

  return (
    <> 
      {/* Page Title */}
      <PageTitle title={'Change Password'} page={'Change Password'} />

      <section className='reset-pwd'>

        {/* Change Password Form */}
        <form className='account-form' onSubmit={handleSubmit}>

          {/* Heading for the Change Password Form */}
          <h3>Change Password!</h3>

          {/* Old Password Input */}
          <div className='input-box'>
            <input type="password" name="old-password" placeholder="enter old password" id="old-password" className='box' />
          </div>

          {/* New Password Input */}
          <div className='input-box'>
            <input type="password" name="new-password" placeholder="enter new password" id="new-password" className='box' />
          </div>

          {/* Confirm Password Input */}
          <div className='input-box'>
            <input type="password" name="confirm-password" placeholder="confirm password" id="confirm-password" className='box' />
          </div>

          {/* Send Link Button */} 
          <button type='submit' name='submit' id='submit' className='btn'>change password</button>

          {/* Registration Link */}
          <p>don't have an account? <Link to='/register' className='link'>register</Link></p>

        </form>
        
      </section>
    </>
  )
}

export default ChangePwd;